import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "pages/auth/Login";
import { Main } from "components/Layout";
import Home from "pages/Home";
import Tables from "pages/Tables";
import { AuthProvider } from "context/AuthContext";
import ProtectedRoute from "components/ProtectedRoute";
import { Result } from "antd";
import {
  Employee,
  Presensi,
  Schedule,
  Customer,
  Courier,
  Checker,
  JobApplication,
  Penghasilan,
  Accurate,
  ImportData,
  MasterData,
} from "pages/delivery";
import { SalesInvoice } from "pages/finance";
import { ReportPenghasilan } from "pages/report";
import {
  Products,
  ProductCategory,
  ProductDetail,
  Banner,
} from "pages/ecommerce";
import Profile from "pages/Profile";
import Dashboard from "pages/Dashboard";
import Promo from "pages/ecommerce/Promo";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Main Layout */}
          <Route element={<Main />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/tables" element={<Tables />} />
            <Route path="/profile" element={<Profile />} />

            {/* Delivery Routes */}
            <Route path="/delivery">
              <Route index element={<Navigate to="accurate" replace />} />
              <Route path="accurate" element={<Accurate />} />
              <Route path="import" element={<ImportData />} />
              <Route path="master-data" element={<MasterData />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="customer" element={<Customer />} />
              <Route path="courier" element={<Courier />} />
              <Route path="checker" element={<Checker />} />
              <Route path="job-application" element={<JobApplication />} />
              <Route path="employee" element={<Employee />} />
              <Route path="presensi" element={<Presensi />} />
              <Route path="penghasilan" element={<Penghasilan />} />
            </Route>

            {/* Finance Routes */}
            <Route path="/finance">
              <Route index element={<Navigate to="sales-invoice" replace />} />
              <Route path="sales-invoice" element={<SalesInvoice />} />
            </Route>

            {/* Ecommerce Routes */}
            <Route path="/ecommerce">
              <Route index element={<Navigate to="product" replace />} />
              <Route path="product" element={<Products />} />
              <Route path="product-category" element={<ProductCategory />} />
              <Route path="banner" element={<Banner />} />
              <Route path="promo" element={<Promo />} />

              <Route path="product/detail/:id" element={<ProductDetail />} />
            </Route>

            {/* Report Routes */}
            <Route path="/report">
              <Route index element={<Navigate to="penghasilan" replace />} />
              <Route path="penghasilan" element={<ReportPenghasilan />} />
            </Route>
          </Route>
        </Route>

        {/* 404 Not Found */}
        <Route
          path="*"
          element={
            <div style={{ padding: "50px", textAlign: "center" }}>
              <Result
                status="404"
                title="404"
                subTitle="Maaf, halaman yang Anda kunjungi tidak ditemukan."
                extra={<a href="/dashboard">Kembali ke Dashboard</a>}
              />
            </div>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
